<ol class="breadcrumb transparent-background font-weight-bold" *ngIf="breadcrumbs.length">
  <li><a routerLink="applications">My Loans</a></li>

  <li *ngFor="let breadcrumb of breadcrumbs; last as isLast" [class.active]="isLast">
    <span *ngIf="isLast">{{ breadcrumb.label }}</span>
    <a *ngIf="!isLast" [routerLink]="breadcrumb.url">{{ breadcrumb.label }}</a>
  </li>
</ol>
